// components/OrderCard.jsx
import React from "react";
import { FaStar, FaStarHalfAlt } from "react-icons/fa";
import { TbWash } from "react-icons/tb";
import laundry from "../../../assets/webp/laundry.webp";
import CustomButton from "../../../component/elements/CustomButton/CustomButton";
import LocalLaundryServiceIcon from "@mui/icons-material/LocalLaundryService";
import { statusClasses, statusToStepMap } from "../../../constants/customer";

export default function OrderCard({ order, cancleOrder, trackOrder ,handlePay }) {
  const isImageAvailable = !!order?.image;
  const status = statusToStepMap[order?.status] || order?.status;
  return (
    <div className="flex flex-col justify-start lgs:flex-row  lgs:items-center lgs:justify-between bg-white rounded-xl shadow-[0_0_10px_rgba(0,0,0,0.08)] px-2 sm:px-3 md:px-4 lg:px-6 py-5 gap-2">
      <div className="flex">
        <div className="w-36 h-24 bg-[#E8F3F8] rounded-xl flex items-center justify-center overflow-hidden mb-3">
          {isImageAvailable ? (
            <img
              src={order.image}
              alt="Laundry"
              className="w-full h-full object-cover"
            />
          ) : (
            <LocalLaundryServiceIcon
              style={{ fontSize: 80 }}
              className="text-[#3383B2]"
            />
          )}
        </div>
        <div className="flex flex-col justify-between h-full  ml-4">
          <div className="text-xs sm:text-base font-[400] text-[#606060]">
            {order?.order_id}
          </div>
          <div className="text-sm font-[400] text-[#606060] mt-2">
            Laundry Name
          </div>
          <div className="text-xs sm:text-base font-bold text-[#063853]">
            {order?.title}
          </div>
          <div className="flex mt-1">
            {[1, 2, 3, 4, 5].map((star) => (
              <FaStar
                key={star}
                size={12}
                className={`md:size-[14px] ${star <= order?.rating ? "text-[#FACC15]" : "text-gray-300"
                  }`}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="h-28 hidden lgs:block border-[1px] border-dotted border-[#D2D2D2]"></div>
      <div className="block lgs:hidden border-t border-dotted my-3 border-[#D2D2D2] w-full" />


      <div className="flex  flex-row lgs:flex-col lgs:justify-centerlgs: items-start min-w-[160px] text-sm">
        <div className="flex items-center gap-2 mb-1">
          <div className="bg-[#E8F7FF] rounded-[4px] p-2 flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10">
            <img src={laundry} alt="laundry" className="w-6 h-6 sm:w-8 sm:h-8" />
          </div>
          <div>
            <div className="text-sm font-[400] text-[#606060]">
              Service Type
            </div>
            <span className="font-[700] text-base lg:text-lg text-[#063853]">
              {order?.service}
            </span>
          </div>
        </div>
        <div>
          <div className="text:sm lg:text-base ml-[50px]">
            <span className="font-[400] text-[#606060]">Weight &nbsp;: </span>
            <span className="text-[#000000] font-[600]">
              {order.totalQuantity}
            </span>
          </div>
          <div className="text:sm lg:text-base ml-[50px]">
            <span className="font-[400] text-[#606060]">Price &nbsp;:</span>{" "}
            <span className="text-[#000000] font-[600]">
              ${order?.totalPrice}
            </span>
          </div>
        </div>
      </div>

      <div className="h-28 hidden lgs:block border-[1px] border-dotted border-[#D2D2D2]"></div>
      <div className="block lgs:hidden border-t border-dotted my-3 border-[#D2D2D2] w-full" />

      <div className="flex flex-col  xs:flex-row  lgs:flex-col items-start min-w-[140px] text-xs text-gray-600">
        <div className="w-full">
          <div className="flex gap-2 ">
            <div className="text-base lgs:text:sm lg:text-base font-[400] text-[#606060]">Order Date</div>
            <div className="text-base lgs:text:sm lg:text-base text-[#000000] font-[600]">
              {order?.placedDate}
            </div>
          </div>
          <div className="flex gap-2">
            <div className="mt-2 text-base lgs:text:sm lg:text-base font-[400] text-[#606060]">
              Order Status
            </div>
            <span
              className={`flex items-center mt-1 px-3 py-1 rounded-full text-xs font-semibold ${statusClasses[status.toLowerCase()]
                }`}
            >
              {status}
            </span>
          </div>
        </div>

        <div className="flex justify-start xs:justify-end lgs:justify-start  mt-2 xs:mt-0 sm:mt-4 w-full">
          {/* <CustomButton
            onClick={() => cancleOrder(order.id)}
            customeClass="customer-light-button w-[115px] h-[28px]"
          >
            Cancel Order
          </CustomButton> */}
          {order?.status === 'Pending' ? (
            <CustomButton
              onClick={() => handlePay(order.id)}
              customeClass="customer-dark-button w-[110px] h-[28px]"
            >
              Pay Now
            </CustomButton>
          ) : (
            <CustomButton
              onClick={() => trackOrder(order.id)}
              customeClass="customer-dark-button w-[110px] h-[28px]"
            >
              Track Order
            </CustomButton>
          )}

        </div>
      </div>
    </div>
  );
}
